<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex justify-content-center">
            <h2>Gerenciamento de autores</h2>
        </div>
        <div class="col-8 mt-4">
            <div class="col-12 d-flex justify-content-center">
                <input type="text" 
                    class="col-6 form-control"
                    v-model="search"
                    placeholder="Pesquisa">
                <router-link
                    class="ml-5 btn btn-primary"
                    :to="{ name: 'NewAuthor' }">
                    cadastrar
                </router-link>
            </div>
        </div>
        <div class="col-6 my-5">
            <DataTables
                v-model="authors"
                :headers="headers"
                :search="search"
                :tr-button="true"
                max_height="700px"
                @by-click-on-tr="Show"
                >

                <template v-slot:body="{ item }">
                    <td>
                        <b class="font-18">{{ item.nome }}</b>
                    </td>
                    <td>
                        <p class="font-18">{{ item.cargo }}</p>
                    </td>
                    <td>
                        {{ ParseDate(item.created_at) }}
                    </td>
                </template>
            </DataTables>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataTables from './../../shared/DataTables'

const _ = require('lodash')

export default {
    name: "ManageAuthors",
    components: {
        DataTables
    },
    data () {
        return {
            authors:         [],
            headers:            [
                { text: 'Nome', value: 'nome', sortable: true },
                { text: 'Cargo', value: 'cargo', sortable: true },
                { text: 'Data de cadastro', value: 'created_at', sortable: true },
            ],
            search:         ""
        }
    },
    computed: {
        ...mapGetters('system', [
            'all_authors'
        ])
    },
    watch: {
        all_authors: {
            immediate: true,
            deep: true,
            handler(val)
            {
                this.authors = _.orderBy(val, 'id', 'asc')
            }
        }
    },
    methods: {
        ...mapActions('system', [
            'GetFaqItems'
        ]),
        Show(author)
        {
            this.$router.push({ name: 'EditAuthor', params: {
                author_id: author.id
            }})
        },
        ParseDate(date)
        {
            if(date)
            {
                let new_date = date.substr(0, 10).split('-').reverse().join('/')

                return new_date
            }
            return ''
        }
    },
    beforeMount()
    {
        this.GetFaqItems()
    }
}
</script>

<style>

</style>